import { Calendar, Col, Radio, Row, Select, Tag } from "antd";
import { CalendarMode } from "antd/es/calendar/generateCalendar";
import dayjs, { Dayjs } from "dayjs";
import { CellRenderInfo } from "rc-picker/lib/interface";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginedLayout } from "../../../components/layout/loginLayout";
import { Box } from "../../../components/styled-components";
import { FormatDateYMD, GetColor } from "../../../functions/function";
import { PATHNAME } from "../../../res/pathName";
import { GET } from "../../../services";
import { CHECKER_CALENDAR } from "../../../services/path";

const OrderMange = () => {
  const [data, setData] = useState<any>([]);
  const [selectedMonth, setSelectedMonth] = useState(dayjs(new Date()));
  const [mode, setMode] = useState<CalendarMode>("month");
  const navigate = useNavigate();
  const isPastDate = selectedMonth.isBefore(dayjs(), "day");
  const fetchData = async () => {
    try {
      const formattedDate = FormatDateYMD(selectedMonth.toDate()); // Assuming FormatDateYMD is a function to format the date
      const result = await GET(CHECKER_CALENDAR(formattedDate));
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedMonth]);

  useEffect(() => {
    const date = localStorage.getItem("date");
    const operationStatus = localStorage.getItem("operationStatus");
    if (date && operationStatus) {
      const url = `${PATHNAME.SEACH_ORDER}`;
      navigate(url);
    }
  }, [navigate]);

  // Handle date selection
  const handleSelectedDate = (date: Dayjs) => {
    localStorage.setItem("date", FormatDateYMD(date.toDate()));
    setSelectedMonth(date); // Update the selectedMonth state
  };

  // Handle operation_status selection
  const handleSelectedStatus = (status: string) => {
    localStorage.setItem("operationStatus", status);
  };

  const dateCellRender = (value: Dayjs) => {
    const date = FormatDateYMD(value);
    const listData = data.filter((item: any) => FormatDateYMD(item.batch_date) === date);
    return (
      <ul style={calendarStyles[".events"]}>
        {listData.map((item: any, index: any) => (
          <li
            key={index}
            style={{
              width: "100%",
              overflow: "hidden",
              fontSize: "12px",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            <Tag
              color={GetColor(item.operation_status)}
              style={{ marginBottom: 2 }}
              onClick={() => {
                handleSelectedStatus(item.operation_status);
                window.location.reload(); // รีเฟรชหน้าเว็บ
              }}
            >
              {`${item.operation_status} : ${item.total}`}
            </Tag>
          </li>
        ))}
      </ul>
    );
  };

  const cellRender = (current: Dayjs, info: CellRenderInfo<Dayjs>) => {
    if (info.type === "date") return dateCellRender(current);
    return info.originNode;
  };

  return (
    <LoginedLayout>
      <Box>
        <Calendar
          mode={mode}
          style={{
            marginBottom: -20,
            marginTop: -20,
            minWidth: "700px",
            color: isPastDate ? "grey" : "inherit",
          }}
          value={selectedMonth}
          onSelect={(date, selectInfo) => {
            if (selectInfo.source === "month") {
              setMode("month");
            } else if (selectInfo.source === "date") {
              handleSelectedDate(date);
            }
          }}
          fullscreen={true}
          cellRender={cellRender}
          headerRender={({ value, type, onChange, onTypeChange }) => {
            const start = 0;
            const end = 12;
            const monthOptions = [];

            let current = value.clone();
            const months = [];
            for (let i = 0; i < 12; i++) {
              current = current.month(i);
              months.push(current.format("MMMM"));
            }

            for (let i = start; i < end; i++) {
              monthOptions.push(
                <Select.Option key={i} value={i} className="month-item">
                  {months[i]}
                </Select.Option>,
              );
            }
            const year = value.year();
            const month = value.month();
            const options = [];
            for (let i = year - 5; i < year + 5; i += 1) {
              options.push(
                <Select.Option key={i} value={i} className="year-item">
                  {i}
                </Select.Option>,
              );
            }

            return (
              <div style={{ padding: 8, paddingRight: 0 }}>
                <Row gutter={8}>
                  <Col>
                    <Radio.Group
                      onChange={(e) => {
                        const now = dayjs(new Date());
                        let newDate;
                        switch (e.target.value) {
                          case "<":
                            newDate = value.clone().add(-1, type);
                            break;
                          case ">":
                            newDate = value.clone().add(1, type);
                            break;
                          case "today":
                            newDate = now;
                            break;
                          default:
                            return;
                        }
                        onChange(newDate);
                        handleSelectedDate(newDate);
                      }}
                      value={type}
                    >
                      <Radio.Button value="<">{"<"}</Radio.Button>
                      <Radio.Button value="today">{"วันนี้"}</Radio.Button>
                      <Radio.Button value=">">{">"}</Radio.Button>
                    </Radio.Group>
                  </Col>
                  <Col>
                    <Radio.Group
                      onChange={(e) => {
                        onTypeChange(e.target.value);
                        setMode(e.target.value);
                      }}
                      value={type}
                    >
                      <Radio.Button value="month">เดือน</Radio.Button>
                      <Radio.Button value="year">ปี</Radio.Button>
                    </Radio.Group>
                  </Col>
                  <Col>
                    <Select
                      className="my-year-select"
                      value={year}
                      onChange={(newYear) => {
                        const now = value.clone().year(newYear);
                        onChange(now);
                        handleSelectedDate(now);
                      }}
                    >
                      {options}
                    </Select>
                  </Col>
                  <Col>
                    <Select
                      style={{ width: "120px" }}
                      value={month}
                      onChange={(newMonth) => {
                        const now = value.clone().month(newMonth);
                        onChange(now);
                        handleSelectedDate(now);
                      }}
                    >
                      {monthOptions}
                    </Select>
                  </Col>
                </Row>
              </div>
            );
          }}
        />
      </Box>
    </LoginedLayout>
  );
};

export default OrderMange;
const calendarStyles = {
  // Define your styles here
  ".events": {
    margin: 0,
    padding: 0,
    listStyle: "none",
  },
  ".events .ant-badge-status": {
    width: "100%",
    overflow: "hidden",
    fontSize: "12px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
};
